import React, { Component, Fragment } from "react";
import {
	Collapse,
	Row,
	Col,
	Button,
	Input,
	Card,
	CardBody,
	Container,
	CardHeader,
	CardText,
	CardFooter,
	CardTitle
} from "reactstrap";

import { BrowserRouter as Router, Link, Route, Switch } from "react-router-dom";

import gsIcon from "../../../assets/img/help/getting-started-icon.png";
import tipsIcon from "../../../assets/img/help/tips-icon.png";
import usingTsIcon from "../../../assets/img/help/using-ts-icon.png";
import troubleshootingIcon from "../../../assets/img/help/troubleshooting-icon.png";
import msgIcon from "../../../assets/img/help/msg.png";

class Help extends Component {
	constructor(props) {
		super(props);
		
		this.toggle = this.toggle.bind(this);

		this.state = {
			collapse: [false, false, false, false, false, false, false, false, false, false],
			collapseTrue: 0,
			list: [
				"How to update",
				"How to change the language",
				"Lost and stolen phones",
				"Restoring your chat history",
				"Why don't I get notifications?",
				"Problems sending or receiving messages",
				"How to send media, contacts or location",
				"How to edit your profile",
				"Can I delete my messages?",
				"How do you encrypt data?"
			],
			articles: [
				"Article 1",
				"Article 2",
				"Article 3",
				"Article 4",
				"Article 5",
				"Article 6",
				"Article 7",
				"Article 8",
				"Article 9",
				"Article 10"
			],
			filtered: []
		};
		this.handleChange = this.handleChange.bind(this);
	}

	componentDidMount() {
		this.setState({
			filtered: this.state.list
		});
	}

	handleChange(e) {
		// Variable to hold the original version of the list
		let currentList = [];
		// Variable to hold the filtered list before putting into state
		let newList = [];

		// If the search bar isn't empty
		if (e.target.value !== "") {
			// Assign the original list to currentList
			currentList = this.state.list;

			// Use .filter() to determine which items should be displayed
			// based on the search terms
			newList = currentList.filter(item => {
				// change current item to lowercase
				const lc = item.toLowerCase();
				// change search term to lowercase
				const filter = e.target.value.toLowerCase();
				// check to see if the current list item includes the search term
				// If it does, it will be added to newList. Using lowercase eliminates
				// issues with capitalization in search terms and search content
				return lc.includes(filter);
			});
		} else {
			// If the search bar is empty, set newList to original task list
			newList = this.state.list;
		}
		// Set the filtered state based on what our rules added to newList
		this.setState({
			filtered: newList
		});
	}

	toggle(index) {
		let collapseArr = [];
		if (this.state.collapse[index] === true) {
			for (let i=0; i<=10; i+=1) {
				   collapseArr.push(false);
			   }
		   } else {
			for (let i=0; i<=10; i+=1) {
				if (i === index) { 
					collapseArr.push(true);
				}
				else { 
					collapseArr.push(false);
				}
			}		   
		}
		this.setState(state => ({ collapse: collapseArr }));
	}

	render() {
		return (
			<Fragment>
				<Row>
					<Col style={{ paddingLeft: "24px" }}>
						<h3 className="page-title">Help</h3>
					</Col>
				</Row>
				<div style={{overflow: "auto", height: "84vh"}} className="m-2 bg-white rounded border border-custom">
					<h2 className="help-title">Hey! How can we help?</h2>
					<br />
					<Row>
						<Col sm="12" md={{ size: 8, offset: 2 }}>
							<Input
								bsSize="lg"
								type="text"
								name="search"
								id="search"
								onChange={this.handleChange}
								placeholder="Search"
							/>
						</Col>
					</Row>
					<Row>
						<Col />
							<Col>
							<Link to="/misc/Help/GettingStarted" style={{textDecoration:"none"}}>
								<Row className="justify-content-center">
									<img className="img-responsive help-icon growhelp" src={gsIcon} />
									<br />
								</Row>
								<Row className="justify-content-center">
									<h4>Getting Started</h4>
									<br />
								</Row>
								</Link>
							</Col>
							<Col>
							<Link to="/misc/Help/UsingTalentScript" style={{textDecoration:"none"}}>
								<Row className="justify-content-center">
									<img className="help-icon growhelp" src={usingTsIcon} />
									<br />
								</Row>
								<Row className="justify-content-center">
									<h4>Using TalentScript</h4>
									<br />
								</Row>
								</Link>
							</Col>
							<Col>
							<Link to="/misc/Help/Troubleshooting" style={{textDecoration:"none"}}>
								<Row className="justify-content-center">
									<img className="help-icon growhelp" src={troubleshootingIcon} />
									<br />
								</Row>
								<Row className="justify-content-center">
									<h4>Troubleshooting</h4>
									<br />
								</Row>
								</Link>
							</Col>
							<Col>
							<Link to="/misc/Help/TipsAndTricks" style={{textDecoration:"none"}}>

								<Row className="justify-content-center">
									<img className="help-icon growhelp" src={tipsIcon} />
									<br />
								</Row>
								<Row className="justify-content-center">
									<h4>Tips & Tricks</h4>
								</Row>
							</Link>
						</Col>
						<Col />
					</Row>

					<hr className="half-rule" />
					<Container>
						<Row style={{ paddingLeft: "calc(16px + 4%)", paddingRight: "calc(16px + 4%)"   }}>
							<Col sm="12" md={{ size: 8 }}>
								<Row>
									<h2 className="help-title">Featured Articles</h2>
								</Row>
								<Row>
									<Col>
										<ul>
											{this.state.filtered.slice(0, this.state.filtered.length/2 + 1).map((item, index) => (
												<li className="mousehover" style={{fontSize:"16px", margin:"8px"}} onClick={() => this.toggle(index)} key={index}>{item}
													<Collapse isOpen={this.state.collapse[index]}>
														<Card style={{fontSize:"16px", padding: "8px", border:"none"}}>{this.state.articles[index]}</Card>
													</Collapse>
												</li>
											))}
										</ul>
									</Col>
									<Col>
										<ul>
											{this.state.filtered.slice(this.state.filtered.length/2 + 1, this.state.filtered.length).map((item, index) => (
												<li className="mousehover" style={{fontSize:"16px",  margin:"8px"}} onClick={() => this.toggle(index + this.state.filtered.length/2 + 1)} key={index + this.state.filtered.length/2 + 1}>{item}
													<Collapse isOpen={this.state.collapse[index + this.state.filtered.length/2 + 1]}>
														<Card style={{fontSize:"16px", padding: "8px", border:"none"}}>{this.state.articles[index + this.state.filtered.length/2 + 1]}</Card>
													</Collapse>
												</li>
											))}
										</ul>
									</Col>
								</Row>
							</Col>
							<Col sm="12" md={{ size: 4 }}>
								<Card>
									<CardHeader
										style={{
											fontWeight: "bold",
											backgroundColor: "white",
											fontSize: "18px",
											color: "#0FAEE8",
											textAlign: "center"
										}}
									>
										Can't find what you're looking for?
									</CardHeader>
									<CardBody>
										<center>
											<img style={{height: "48px", width: "48px"}} src={msgIcon} />
											<CardText style={{ fontSize: "16px", marginTop: "8px" }}>
												Feedback, troubles, anything. Let us know and we will
												respond ASAP.
											</CardText>
											<Button color="primary">Contact Us</Button>
										</center>
									</CardBody>
								</Card>
							</Col>
						</Row>
					</Container>
				</div>
			</Fragment>
		);
	}
}

export default Help;
